import React from 'react';
import './EmptyState.css'; // Импортируем стили

function EmptyState() {
  return (
    <div className="emptystate__container">
      <div className="emptystate__panel">
        <h2 className="emptystate__title">Сервис упрощения юридических документов</h2>
        <div className="emptystate__description">
          <p>
            Этот сервис помогает сделать юридические документы более понятными, сохраняя при этом их правовую значимость.
          </p>
          <div className="emptystate__features">
            <h3 className="emptystate__subtitle">Возможности сервиса:</h3>
            <ul>
              <li>Упрощение сложных юридических формулировок</li>
              <li>Сохранение структуры и нумерации документа</li>
              <li>Параллельное отображение оригинала и упрощенной версии</li>
            </ul>
          </div>
          <div className="emptystate__guide">
            <h3 className="emptystate__subtitle">Как использовать:</h3>
            <p>
              Нажмите кнопку "Добавить документ" слева и загрузите файл в формате .docx для обработки.
              После загрузки вы сможете видеть оригинальный текст и его упрощенную версию параллельно.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmptyState; 
